/**
 * Un mot de passe initial à communiquer à un élève.
 *
 * <p>Il ne sert qu'une fois : le serveur le pose comme <i>temporaire</i>, et
 * Keycloak fait choisir à l'élève le sien à sa première connexion. Il doit donc
 * surtout se lire et se dicter sans erreur — d'où l'absence des caractères qui
 * se confondent (0/O, 1/l/I) — tout en passant une politique de mot de passe
 * courante : au moins une minuscule, une majuscule, un chiffre et un symbole.</p>
 *
 * <p>Tiré de `crypto.getRandomValues`, jamais de `Math.random`.</p>
 */
const LOWER = 'abcdefghijkmnpqrstuvwxyz';
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%*?-';
const ALL = LOWER + UPPER + DIGITS + SYMBOLS;

export const TEMPORARY_PASSWORD_LENGTH = 12;

export function generateTemporaryPassword(length = TEMPORARY_PASSWORD_LENGTH): string {
  const pick = (alphabet: string) => alphabet[randomIndex(alphabet.length)];
  const chars = [pick(LOWER), pick(UPPER), pick(DIGITS), pick(SYMBOLS)];
  while (chars.length < length) chars.push(pick(ALL));

  // Mélange de Fisher-Yates : les quatre classes imposées ne restent pas en tête.
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}

/** Un entier uniforme dans [0, max), sans biais de modulo. */
function randomIndex(max: number): number {
  const limit = Math.floor(0x1_0000_0000 / max) * max;
  const buffer = new Uint32Array(1);
  do {
    crypto.getRandomValues(buffer);
  } while (buffer[0] >= limit);
  return buffer[0] % max;
}
